// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko1sit{border-radius:var(--ds-border-radius,3px)}._18m91wug{overflow-y:auto}\n._1reo1wug{overflow-x:auto}\n._1tke1lk4{min-height:520px}\n._1tke1yw0{min-height:45pc}\n._1tkenklw{min-height:20pc}\n._1tkezwhf{min-height:calc(100vh - 119px)}\n._4t3i10fc{height:90vh}\n._4t3i1osq{height:100%}\n._4t3i1rxh{height:70vh}\n._4t3i1tmh{height:20vh}\n._4t3i1wug{height:auto}\n._4t3ivzbd{height:40vh}\n._bfhk13b4{background-color:var(--_1f6rtr1)}", ""]);
// Exports
module.exports = exports;
